// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Wt4j","row":"Node_row__2orbo","label":"Node_label__3hmaZ","footer":"Node_footer__25ifA"};